module.exports = __webpack_public_path__ + "img/logo.a1f90a46.png";